import React, { useState } from 'react';
import { Stacker, Paper, TypographyHeading, Button } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { HotelStaticRoomCard } from './HotelStaticRoomCard';
import { interjectResourceString } from '../../../utils';
export function HotelStaticRooms({ masterRooms: staticMasterRooms }) {
    const { resourceStrings: { ROOMSHOWMORE, HOTEL_DETAILS_TAB_ROOMS }, } = useGlobalContext();
    const defaultRoomLength = 4;
    const [showAll, setShowAll] = useState(false);
    const handleShowMore = () => {
        setShowAll(true);
    };
    return (React.createElement(Paper, { py: 5, defaultGutters: true },
        React.createElement(Stacker, { spacing: 4, "data-id": "rooms" },
            React.createElement(TypographyHeading, { component: "h2", size: "s", color: "text.body", "data-id": "rooms-heading" }, HOTEL_DETAILS_TAB_ROOMS),
            React.createElement(Stacker, { spacing: 4, "data-id": "master-rooms" }, staticMasterRooms
                .slice(0, showAll ? staticMasterRooms.length : defaultRoomLength)
                .map((room, index) => {
                return React.createElement(HotelStaticRoomCard, { masterRoom: room, key: `master-room-${index.toString()}` });
            })),
            !showAll && staticMasterRooms.length > defaultRoomLength && (React.createElement(Button, { color: "primary", size: "l", variant: "outlined", fullWidth: true, onClick: handleShowMore, "data-id": "show-more-rooms" }, `${interjectResourceString(ROOMSHOWMORE, staticMasterRooms.length - defaultRoomLength)}`)))));
}
